// extracted by mini-css-extract-plugin
export default {"cls1":"PostComments-cls1_KAw","cls2":"PostComments-cls2_Ula PostComments-cls1_KAw"};